/* import __COLOCATED_TEMPLATE__ from './rest-api-ip-allowlist-settings.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { run } from '@ember/runloop';
import type IntlService from 'ember-intl/services/intl';
import type SecurityAppSettings from 'embercom/models/security-app-settings';
import type { ComponentLike } from '@glint/template';

interface RestApiIpAllowlistSettingsArgs {
  settings: SecurityAppSettings;
}

interface Signature {
  Args: RestApiIpAllowlistSettingsArgs;
}

export default class RestApiIpAllowlistSettings extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare intercomEventService: $TSFixMe;
  @service declare appService: AppService;

  @tracked settings = this.args.settings;

  get descriptionText(): string {
    return this.intl.t('apps.app.settings.security.rest-api-ip-allowlist-new-description');
  }

  get isInvalid(): boolean {
    return !this.settings.restApiIpValidator.isValid;
  }

  @action
  toggleAllowlistEnabled(): void {
    this.settings.restApiIpAllowlistEnabled = !this.settings.restApiIpAllowlistEnabled;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'rest_api_ip_allowlist_switch',
      rest_api_ip_allowlist_enabled: this.settings.restApiIpAllowlistEnabled,
    });
  }

  @action
  updateIpAllowlist(): void {
    // We need to run this in a runloop because the the on modifier does not schedule the event listener onto the run loop
    // https://github.com/emberjs/ember.js/issues/19222#issuecomment-1049773929
    run(() => {
      this.settings.updateRestApiIpAllowlist();
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Settings::Security::RestApiIpAllowlistSettings': ComponentLike<{ Args: { settings: any } }>;
    'settings/security/rest-api-ip-allowlist-settings': ComponentLike<{ Args: { settings: any } }>;
  }
}
